/**
 * MenuController
 * ハンバーガーメニューの開閉を管理する
 * ページ内に複数の .menu-trigger が存在してもすべてが同一の .menu をトグルできるように
 * NodeList でまとめて扱う (例: header と #top で trigger を分ける構成)
 *
 * ★ Barba 対応: .menu-trigger / .menu は header.php 側 (barba container 外) にあり
 *   DOM が遷移で入れ替わらない。init() が SPA 遷移ごとに再実行されるため、
 *   前回登録した click handler を必ず解除してから貼り直す
 *   (放置すると遷移ごとに handler が増えて偶数回でトグルが打ち消される)。
 */
export const MenuController = {
  triggers: [],
  nav: null,
  isOpen: false,
  _onClick: null,

  init() {
    // 前回分の listener を解除
    if ( this._onClick ) {
      this.triggers.forEach( ( t ) => t.removeEventListener( 'click', this._onClick ) );
      this._onClick = null;
    }

    this.triggers = Array.from( document.querySelectorAll( '.menu-trigger' ) );
    this.nav      = document.querySelector( '.menu' );
    if ( this.triggers.length === 0 || !this.nav ) return;

    // 関数参照を保持し、次回 init で確実に解除できるようにする
    this._onClick = () => this.toggle();
    this.triggers.forEach( ( t ) => {
      t.addEventListener( 'click', this._onClick );
    } );
  },

  toggle() {
    this.isOpen = !this.isOpen;
    this.triggers.forEach( ( t ) => {
      t.classList.toggle( 'is-active', this.isOpen );
      t.setAttribute( 'aria-expanded', String( this.isOpen ) );
    } );
    this.nav.classList.toggle( 'is-open', this.isOpen );
    // menu 開閉と連動して body に .menu-open を付与
    // → SCSS 側で #header の .hide を打ち消して常時表示にする
    document.body.classList.toggle( 'menu-open', this.isOpen );
    document.body.style.overflow = this.isOpen ? 'hidden' : '';
  },

  close() {
    this.isOpen = false;
    this.triggers.forEach( ( t ) => {
      t.classList.remove( 'is-active' );
      t.setAttribute( 'aria-expanded', 'false' );
    } );
    this.nav?.classList.remove( 'is-open' );
    document.body.classList.remove( 'menu-open' );
    document.body.style.overflow = '';
  },
};
